import { ParsedUrlQueryInput } from 'querystring';
import React from 'react';

export const DEFAULT_DURATION_MS = 160;

export const transition = (...properties: Array<string | [string, number]>) =>
  properties
    .map((property) => {
      let duration = DEFAULT_DURATION_MS;
      if (typeof property !== 'string') {
        duration = property[1];
        property = property[0];
      }
      return `${property} ease-out ${duration}ms`;
    })
    .join(', ');

export interface NavItemData {
  name: string;
  tooltip?: string;
  objectId?: string;
  location: {
    pathname: string;
    query?: ParsedUrlQueryInput;
    search?: string;
    hash?: string;
  };
  chip?: string | null;
  chipTooltip?: string;
  disabled?: boolean;
  hasPermission: boolean;
  openInNewTab?: boolean;
  dataTest?: string;
  subentries?: Array<NavItemData>;
}

export interface NavSectionData extends NavItemData {
  subentries: Array<NavItemData>;
  icon?: React.ElementType;

  // Used to apply a grey50 text style for use as a section header
  flatSection?: boolean;

  // Used for the "Add" button in the top level section
  onAdd?: () => void;

  // Used in cases where the top level item is actually styled as a nav item
  isNavItem?: boolean;

  collapsed?: boolean;
}

// PROTOTYPE NAV

export interface NavSectionHeader {
  icon: React.ElementType;
  name: string;
  tooltip?: string;
  subitems: Array<NavSectionItem>;
  disabled: boolean;
  hasPermission: boolean;
  href?: string;
}

export interface NavSectionItem {
  name: string;
  tooltip?: string;
  href: string;
  disabled: boolean;
  hasPermission: boolean;
  // maybe add featureflags here?
}

export interface SideBarVariant {
  navEntries: Array<NavSectionData>;
  syntheticNavEntries?: Array<NavSectionData>;
  contentAfterNavEntries?: (props: {
    appearsCollapsed: boolean;
    activeEntry: NavItemData | null;
  }) => JSX.Element;
}
